import ProspectTemplateCategory from './ProspectCategory/ProspectTemplateCategory';
import ProspectTemplateHome from './ProspectHome/ProspectTemplateHome';
import ProspectTemplateHomePartner from './ProspectPartner/ProspectTemplatePartner';
import SuccessTemplate from './Success/SuccessTemplate';
import SignupTemplate from './Signup/SignupTemplate';
import SignupSuccessTemplate from './Signup/SignupSuccessTemplate';
import ForgotPasswordTemplate from './ForgotPassword/ForgotPasswordTemplate';
import RedefinePasswordTemplate from './RedefinePassword/RedefinePasswordTemplate';
import DocumentsValidationTemplate from './DocumentsValidation/DocumentsValidation';
import ManualDocumentsValidationTemplate from './ManualDocumentsValidation/ManualDocumentsValidation';
import LoginTemplate from './Login/LoginTemplate';
import ExternalProfileTemplate from './ProfileExternal/ExternalProfileTemplate';
import InternalProfileTemplate from './ProfileInternal/InternalProfileTemplate';
import WebCheckoutTemplate from './WebCheckout/WebCheckoutTemplate';
import WebCheckoutTemplateIOS from './WebCheckout/WebCheckoutTemplateIOS';
import SignupMGMTemplate from './MGM/SignupMGMTemplate';
import { ErrorTemplate } from './ErrorTemplate/ErrorTemplate';
import AdsTemplate from './Ads/AdsTemplate';
import NewStoreWebTemplate from './NewStore/NewStoreWebTemplate';

export {
  ProspectTemplateCategory,
  ProspectTemplateHome,
  ProspectTemplateHomePartner,
  SuccessTemplate,
  SignupTemplate,
  SignupSuccessTemplate,
  DocumentsValidationTemplate,
  ManualDocumentsValidationTemplate,
  LoginTemplate,
  ExternalProfileTemplate,
  InternalProfileTemplate,
  WebCheckoutTemplate,
  WebCheckoutTemplateIOS,
  SignupMGMTemplate,
  ErrorTemplate,
  AdsTemplate,
  ForgotPasswordTemplate,
  RedefinePasswordTemplate,
  NewStoreWebTemplate,
};
